<template>
  <div class="exhibition-dom">
    <NavHeaderBar title="网上展厅" :onClickRight="onClickRight" rightArrow />
    <div>

      <div class="empty" v-if="list.length < 1">敬请期待</div>


      <ul class="exhibition-dom-list" v-if="list.length > 0">
        <li v-for="item in list" :key="item.id">
          <div class="company" @click="onClick(item)">
            <div class="logo">
              <img :src="item.logo" alt="logo.png" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";
import { Toast } from "vant";
import { mapActions, mapState } from "vuex";
export default {
  name: "Exhibition",
  mixins: [share],
  mounted: function () {
    document.title = this.title;
    if (this.$route.query.id) {
      this.queryExhibitionList(this.$route.query.id).then(res => {
        console.info(res);
        if (getEnv() !== "h5" && res.success == "ok") {
          const { shareimg, sharedesc, projectTitle } = res.data;
          document.title = projectTitle;
          this.onShare({
            link:
              window.location.href.split("?")[0] +
              "?id=" +
              this.$route.query.id +
              "&isConference=" +
              this.$route.query.isConference+
              "&source=" + this.$route.query.source,
            title: projectTitle + "网上展厅",
            imgUrl: shareimg,
            desc: sharedesc
          });
        }
      });
    } else {
      this.$router.replace("/");
    }
  },
  computed: {
    ...mapState({
      list: state => state.exhibition.list,
      title: state => state.exhibition.title
    })
  },

  methods: {
    ...mapActions({
      queryExhibitionList: "exhibition/queryExhibitionList"
    }),
    onClickRight() {
      const { isConference, id, source } = this.$route.query;

      if (source && (source != 'undefined')) {
        this.$router.push({
          path: source,
          query: { project: id }
        });
      }

      else if (isConference) {
        this.$router.replace({
          path: isConference ? "/conference" : "/livehome",
          query: { [isConference ? "code" : "project"]: id }
        });
      }
    },
    onClick(row) {
      if (!row.introductionPic && !row.introductionVideo) {
        return Toast("请完善资料");
      }
      const { source } = this.$route.query;

      this.$router.push({
        path: "/exhibition/detail",
        query: {
          project: this.$route.query.id,
          id: row.id,
          isConference: this.$route.query.isConference,
          source: source
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.exhibition-dom {
  padding-top: 46px;
  background-color: #ededed;

  .content {
    padding: 0 12px;
  }

  .exhibition-dom-list {
    display: flex;
    flex-direction: column;
    margin-top: 7px;

    .company {
      max-width: 414px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-items: center;
      margin-bottom: 10px;
      box-sizing: border-box;

      .logo {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .content {
        flex: 2;
        line-height: 22px;
        font-size: 17px;
        color: #333;
        font-weight: 700;
      }
    }
  }

  .empty {
    width: 100%;
    text-align: center;
    padding-top: 40px;
    font-size: 20px;
    background-color: #fff;
  }


}
</style>
